<template>
  <Menu/>
<router-view />
  <Footer/>
</template>

<script>

import Menu from './components/MenuComponent.vue';
import Footer from './components/FooterComponent.vue';

export default {
  
  methods: {
    redirectPage(param) {
      this.$router.push( '/'+ param);
    }
  },
  components: {
    'Menu' : Menu,
    'Footer' : Footer,
    // 'Preloader' : Preloader,
  },
}
</script>

<style lang="css">

</style>
